// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_3-0";
export var footer = "_3-2";
export var infoSection = "_3-3";
export var infoSectionContainer = "_3-4";
export var infoSectionTitleRow = "_3-5";
export var itemDetails = "_3-6";
export var line = "_3-7";
export var lineItemImage = "_3-1";
export var lineItems = "_3-8";
export var modalContent = "_3-9";
export var multiLineInfo = "_3-a";
export var orderName = "_3-b";
export var strong = "_3-c";